/**
 * Menu types — the `menu_type` taxonomy in the WordPress original
 * (multi-assignable per dish: a dish can appear on several menus).
 *
 * `sort` is the fixed display order (daily, formule, carte), ported from
 * the $mt_order map in child-theme/inc/menu-editor.php.
 */
export const MENU_TYPES = [
  { slug: 'daily', label: 'Menu du Jour', sort: 1 },
  { slug: 'formule', label: 'La Formule', sort: 2 },
  { slug: 'carte', label: 'La Carte', sort: 3 },
] as const;

export type MenuTypeSlug = (typeof MENU_TYPES)[number]['slug'];

export const MENU_TYPE_SLUGS: readonly MenuTypeSlug[] = MENU_TYPES.map((m) => m.slug);
